<template>

    <div class="search">

        <div class="search__body" :class="{'search__body__white': isBodyWhite}" v-if="searchValue">

            <div class="count-result" v-show="list.length">
                {{ computedTextSearching }}
            </div>

            <div class="info-result" v-show="!list.length">

                <p class="color__charcoal"
                   :class="{
                'text-baseMedium': !isDesktop,
                'text-xlSemibold-2': isDesktop
            }">
                    {{ computedTextSearching }}
                </p>

                <p class="color__moon mt__8"
                   :class="{
                'text-baseRegular-2': !isDesktop,
                'text-lMedium': isDesktop
            }"
                   v-show="list.length === 0">{{ $t('cleaning_search_suggestion') }}</p>
            </div>
        </div>

    </div>

</template>

<script>
import Tag from '@/modules/tag'

export default {

    name: 'search',

    props: {
        list: {
            type: Array,
            default: () => []
        },
        searchValue: {
            type: String,
            default: ''
        }
    },

    watch: {
        list() {
            if (this.searchValue && this.list.length === 0) {
                Tag.clickGA(this, 'search_result_empty')
            }
        }
    },

    computed: {

        computedTextSearching() {
            return this.list.length
                ? this.$tc('cleaning_search_nb_results', this.list.length, {
                    'nb_results': this.list.length,
                    search: this.searchValue
                })
                : this.$t('cleaning_search_no_results')
        },

        isBodyWhite() {
            return this.isDesktop && this.list.length === 0
        }
    }
}

</script>

<style lang="scss" scoped>

.search {
    @media screen and (min-width: $above-tablet-length) {
        background-color: $white;
    }

    &__body {
        display: flex;
        flex-direction: column;
        background-color: $timberwolf;
        padding: 16px 16px 8px;
        text-align: center;
        margin-bottom: 1px;
        color: $neutralsMoon;
        @media screen and (min-width: $above-tablet-length) {
            padding: 24px 32px 44px;
            text-align: start;
            margin: 0;
        }

        &__white {
            background-color: $white;
            padding-top: 57px;
        }

        .count-result {
            text-align: start;
            @media screen and (min-width: $above-tablet-length) {
                text-align: center;
            }
        }

        .info-result {
            text-align: center;
        }
    }

    &__title {
        display: flex;
        flex-direction: row;
    }
}
</style>